import React from "react";
import { observer } from "mobx-react";
import { makeStyles } from "@mui/styles";
import { Backdrop, CircularProgress } from "@mui/material";

const useLoaderStyles = makeStyles({
  backdrop: {
    zIndex: 999999,
    color: "#fff",
  },
});

const Loader = ({ loading }) => {
  const classes = useLoaderStyles();
  if (loading) {
    return (
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress />
      </Backdrop>
    );
  }
};

export default observer(Loader);
